import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=8ede50e8&scoped=true&"
import script from "./cancel.vue?vue&type=script&lang=js&"
export * from "./cancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ede50e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ede50e8')) {
      api.createRecord('8ede50e8', component.options)
    } else {
      api.reload('8ede50e8', component.options)
    }
    module.hot.accept("./cancel.vue?vue&type=template&id=8ede50e8&scoped=true&", function () {
      api.rerender('8ede50e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/actions/cancel.vue"
export default component.exports